var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.toggle}},[_c('v-list-item-content',[_c('v-list-item-title',[_c('span',[_vm._v(_vm._s(_vm.title))])])],1),_c('v-list-item-action',[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":"12","color":"secondary"}}):_c('v-icon',{attrs:{"small":"","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }